export function doAsync(func: () => void, deadline = 50): number {
  if (typeof window !== 'undefined' && window.requestIdleCallback) {
    return window.requestIdleCallback(func, { timeout: deadline })
  } else {
    return window.setTimeout(func, deadline)
  }
}
